import { FuelTypography } from '@frete.com/fuel-react';
import React from 'react';
import { TRUCKER_SUPPORT_NUMBER } from '@/constants';

export const ContactInfo: React.FC = () => (
  <FuelTypography size="body-sm" color="neutral-default">
    Se o motorista precisar de ajuda para se cadastrar, peça a ele para falar com nosso atendimento{' '}
    <FuelTypography size="body-sm" color="inherit" weight="medium" displayInline>
      {TRUCKER_SUPPORT_NUMBER}.
    </FuelTypography>
  </FuelTypography>
);
